/* GENERATED FROM commonHdr.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import * as base from './base.service'

export interface HttpRequest {
  headers?: HttpRequest_HeadersEntry
  cookies?: HttpRequest_CookiesEntry
}

export interface HttpRequest_HeadersEntry {
  [key: string]: string
}

export interface HttpRequest_CookiesEntry {
  [key: string]: string
}

export interface RSAPublicKey {
  n?: string
  e?: string
}

export interface Token {
  content?: Token_ContentEntry
}

export interface Token_ContentEntry {
  [key: string]: string
}

export interface MetaInfo {
  request?: HttpRequest
  token?: Token
}

export interface TenantInfo {
  tenant_id?: string
  address?: string
  root_user_id?: string
  user_pool_id?: string
  userpool_jwt_credentials?: TenantInfo_UserpoolJwtCredentialsEntry
  client_id?: string
  account_info?: base.AccountInfo[]
  user_ids?: string[]
  update_time?: string
  name_space?: string
  polling_frequency?: string
  shadow_accounts?: TenantInfo_ShadowAccountsEntry
  graphdb_inventory_version?: number
  inventory_version?: number
  url?: string
  onboarding_done?: boolean
  organization_info?: base.OrganizationInfo[]
  userSource?: UserSource
  idn_pod?: string
  idn_tenant_id?: string
}

export interface TenantInfo_UserpoolJwtCredentialsEntry {
  [key: string]: RSAPublicKey
}

export interface TenantInfo_ShadowAccountsEntry {
  [key: string]: string
}

export interface UserInfo {
  tenant_ids?: string[]
  email?: string
  role?: string
  first_name?: string
  last_name?: string
  alert_info?: AlertInfo
  notification_email_id?: string[]
  phone_number?: string
  location?: string
  name_space?: string
  verification_code?: string
  MFA_enabled?: boolean
  syslog_servers?: SyslogServerInfo[]
  slack_channel?: string
  userSource?: UserSource
  username?: string
  rights?: string[]
}

export interface SyslogServerInfo {
  network?: string
  endpoint?: string
  credentials?: SyslogCredInfo
}

export interface SyslogCredInfo {
  username?: string
  password?: string
}

export interface AlertInfo {
  changes_in_config?: boolean
  health_and_dialog_issue_found?: boolean
  new_user_found?: boolean
  licence_policy_issues?: boolean
  low?: boolean
  medium?: boolean
  high?: boolean
}

export interface CommonTypeCount {
  type?: string
  total_count?: number
  high_count?: number
  medium_count?: number
  low_count?: number
}

export interface ObjectDetails {
  type?: string
  name?: string
  account_id?: string
  URI?: string
  status?: ObjectChangeStatusEnum
  sub_type?: ObjectSubordinationEnum
}

export interface ServerTableReq {
  sorted_field?: string
  sorted_asc?: boolean
  page_number?: number
  page_size?: number
  search_filter?: string
  search_fields?: string[]
  query?: string
}

export interface SearchResultTableRow {
  identity?: string
  identity_uri?: string
  resource?: string
  resource_uri?: string
  policies?: string[]
  actions?: string[]
  identityAccountID?: string
  identityRegion?: string
  resourceAccountID?: string
  resourceRegion?: string
  identity_type?: ResourceTypeEnum
  resource_type?: ResourceTypeEnum
  total_actions?: SearchResultTableRow_TotalActionsEntry
  used_actions?: SearchResultTableRow_UsedActionsEntry
  last_active_time?: string
  policies_count?: number
}

export interface SearchResultTableRow_TotalActionsEntry {
  [key: string]: number
}

export interface SearchResultTableRow_UsedActionsEntry {
  [key: string]: number
}

export interface UsageInfo {
  resource_name?: string
  resource_account_id?: string
  event_name?: string
  timestamp?: string
  ip_address?: string
  resource_type?: string
  identity_name?: string
  identity_type?: string
  identity_account_id?: string
  user_agent?: string
  event_id?: string
  identity_uri?: string
  resource_uri?: string
}

export interface UsageResp {
  resp_hdr?: base.RespHdr
  pages_count?: number
  usage_info_list?: UsageInfo[]
}

export interface AutoCompleteUsedInResp {
  start_timestamp?: string
  end_timestamp?: string
  query?: string
}

export interface coordinates {
  latitude?: number
  longitude?: number
}

export interface GetProgressResp {
  resp_hdr?: base.RespHdr
  last_run?: string
  elapsed_time?: number
  run_by?: string
  next_scheduled_snapshot?: string
  progress_list?: OnboardingProgress[]
  organization_detail?: OrganizationDetail[]
  source_detail?: SourceDetail[]
}

export interface OrganizationDetail {
  organization_source?: OrganizationSource
  organization_state?: OrganizationState
}

export interface OrganizationSource {
  cloud_type?: string
  organization_name?: string
  organization_id?: string
}

export interface OrganizationState {
  current_phase_enum?: string
  current_phase_string?: string
  progress_list?: OnboardingProgress[]
}

export interface SourceDetail {
  source?: Source
  source_state?: SourceState
}

export interface Source {
  cloud_type?: string
  account_name?: string
  account_id?: string
}

export interface SourceState {
  current_phase_enum?: string
  current_phase_string?: string
  progress?: number
  status?: string
  status_reason?: string
}

export interface OnboardingProgress {
  account_id?: string
  account_name?: string
  progress?: number
  status?: string
  status_reason?: string
}

export interface CommonVMInfo {
  vpc_id?: string
  subnet_ids?: string[]
  ip_addresses?: string[]
  public_ip_addresses?: string[]
  sg_ids?: string[]
  open_ports_with_proto?: string
}

export interface CommonSGInfo {
  rules?: SGRule[]
  Description?: string
}

export interface SGRule {
  ports?: string[]
  ip_protocol?: string
  ip_range?: string[]
  ipv6_range?: string[]
  direction?: string
  deny?: boolean
  description?: string
}

export interface CommonRTInfo {
  subnet_uris?: string[]
  vpc_uris?: string[]
  routes?: RouteInfo[]
}

export interface RouteInfo {
  id?: string
  name?: string
  destination?: string
  next_hop?: string
  is_enabled?: boolean
}

export interface NotificationInfo {
  severity?: AlertSeverityEnum
  email?: string[]
  slack_url?: string[]
  syslog?: SyslogServerInfo[]
}

export enum AlertSeverityEnum {
  ALERT_SEVERITY_NONE = 'ALERT_SEVERITY_NONE',
  ALERT_SEVERITY_HIGH = 'ALERT_SEVERITY_HIGH',
  ALERT_SEVERITY_MEDIUM = 'ALERT_SEVERITY_MEDIUM',
  ALERT_SEVERITY_LOW = 'ALERT_SEVERITY_LOW'
}

export enum AlertStatusEnum {
  ALERT_STATUS_NONE = 'ALERT_STATUS_NONE',
  ALERT_STATUS_NEW = 'ALERT_STATUS_NEW',
  ALERT_STATUS_OPEN = 'ALERT_STATUS_OPEN',
  ALERT_STATUS_IGNORE = 'ALERT_STATUS_IGNORE',
  ALERT_STATUS_CLOSE = 'ALERT_STATUS_CLOSE'
}

export enum ResourceLevelEnum {
  UNKNOWN_LEVEL = 'UNKNOWN_LEVEL',
  BUCKET_LEVEL_BUCKET = 'BUCKET_LEVEL_BUCKET',
  BUCKET_LEVEL_OBJECT = 'BUCKET_LEVEL_OBJECT'
}

export enum ResourceTypeEnum {
  UNKNOWN = 'UNKNOWN',
  IDENTITY_START = 'IDENTITY_START',
  ROLE = 'ROLE',
  GROUP = 'GROUP',
  USER = 'USER',
  SCOPE = 'SCOPE',
  RESOURCE_START = 'RESOURCE_START',
  NETWORK_NODE = 'NETWORK_NODE',
  PUBLIC_NODE = 'PUBLIC_NODE',
  GCP_DOMAIN = 'GCP_DOMAIN',
  FEDERATED_USER = 'FEDERATED_USER',
  FEDERATED_GROUP = 'FEDERATED_GROUP',
  AWS_IDENTITY_PROVIDER = 'AWS_IDENTITY_PROVIDER',
  ROLE_SCOPE = 'ROLE_SCOPE',
  AZURE_SERVICE_PRINCIPAL = 'AZURE_SERVICE_PRINCIPAL',
  GCP_SERVICE_ACCOUNT = 'GCP_SERVICE_ACCOUNT',
  SERVICE_ACCOUNT = 'SERVICE_ACCOUNT',
  AZURE_VIRTUAL_MACHINE = 'AZURE_VIRTUAL_MACHINE',
  AWS_INSTANCE = 'AWS_INSTANCE',
  GCP_VM_INSTANCE = 'GCP_VM_INSTANCE',
  IDENTITY_END = 'IDENTITY_END',
  INSTANCE = 'INSTANCE',
  SECURITY_GROUP = 'SECURITY_GROUP',
  LOAD_BALANCER = 'LOAD_BALANCER',
  SUBNET = 'SUBNET',
  SERVERLESS_COMPUTE = 'SERVERLESS_COMPUTE',
  ROUTE_TABLE = 'ROUTE_TABLE',
  OBJECT_STORE = 'OBJECT_STORE',
  VPC = 'VPC',
  RELATIONAL_DB = 'RELATIONAL_DB',
  NOSQL_DB = 'NOSQL_DB',
  DISK = 'DISK',
  KEYSTORE = 'KEYSTORE',
  AWS_EBS = 'AWS_EBS',
  AWS_STS = 'AWS_STS',
  AWS_DYNAMO_DB_TABLE = 'AWS_DYNAMO_DB_TABLE',
  AWS_ELB = 'AWS_ELB',
  AWS_CLOUDWATCH_METRIC = 'AWS_CLOUDWATCH_METRIC',
  AWS_CLOUD_TRAIL = 'AWS_CLOUD_TRAIL',
  AWS_CONFIG_SERVICE = 'AWS_CONFIG_SERVICE',
  AWS_SNS_TOPIC = 'AWS_SNS_TOPIC',
  AWS_CREDENTIAL_REPORT = 'AWS_CREDENTIAL_REPORT',
  AWS_REDSHIFT = 'AWS_REDSHIFT',
  AWS_EFS = 'AWS_EFS',
  AWS_CLOUDFRONT = 'AWS_CLOUDFRONT',
  AWS_SERVER_CERT = 'AWS_SERVER_CERT',
  AWS_S3_PROFILE = 'AWS_S3_PROFILE',
  AWS_SUBNET = 'AWS_SUBNET',
  AWS_SECURITY_GROUP = 'AWS_SECURITY_GROUP',
  AWS_RDS = 'AWS_RDS',
  AWS_VPC = 'AWS_VPC',
  AWS_VPC_ENDPOINT = 'AWS_VPC_ENDPOINT',
  AWS_KMS = 'AWS_KMS',
  AWS_S3 = 'AWS_S3',
  AWS_NACL = 'AWS_NACL',
  AWS_SCP = 'AWS_SCP',
  AWS_PREFIX_LIST = 'AWS_PREFIX_LIST',
  AWS_RT = 'AWS_RT',
  AWS_ALEXA_FOR_BUSINESS = 'AWS_ALEXA_FOR_BUSINESS',
  AWS_AMPLIFY = 'AWS_AMPLIFY',
  AWS_APPLICATION_AUTOSCALING = 'AWS_APPLICATION_AUTOSCALING',
  AWS_APPLICATION_DISCOVERY = 'AWS_APPLICATION_DISCOVERY',
  AWS_APPSTREAM = 'AWS_APPSTREAM',
  AWS_APPSYNC = 'AWS_APPSYNC',
  AWS_ARTIFACT = 'AWS_ARTIFACT',
  AWS_ATHENA = 'AWS_ATHENA',
  AWS_AUTOSCALING_PLANS = 'AWS_AUTOSCALING_PLANS',
  AWS_BACKUP = 'AWS_BACKUP',
  AWS_ELASTICBEANSTALK = 'AWS_ELASTICBEANSTALK',
  AWS_GLUE = 'AWS_GLUE',
  AWS_SQS = 'AWS_SQS',
  AWS_HEALTH = 'AWS_HEALTH',
  AWS_API_GATEWAY = 'AWS_API_GATEWAY',
  AWS_BATCH = 'AWS_BATCH',
  AWS_BILLING = 'AWS_BILLING',
  AWS_BUDGET = 'AWS_BUDGET',
  AWS_CERTIFICATE_MANAGER = 'AWS_CERTIFICATE_MANAGER',
  AWS_CERTIFICATE_MANAGER_PRIVATE = 'AWS_CERTIFICATE_MANAGER_PRIVATE',
  AWS_CHIME = 'AWS_CHIME',
  AWS_CLOUD_DIRECTORY = 'AWS_CLOUD_DIRECTORY',
  AWS_CLOUD_MAP = 'AWS_CLOUD_MAP',
  AWS_CLOUD9 = 'AWS_CLOUD9',
  AWS_CLOUD_FORMATION = 'AWS_CLOUD_FORMATION',
  AWS_CLOUD_FRONT = 'AWS_CLOUD_FRONT',
  AWS_CLOUD_HSM = 'AWS_CLOUD_HSM',
  AWS_CLOUD_SEARCH = 'AWS_CLOUD_SEARCH',
  AWS_CLOUD_WATCH = 'AWS_CLOUD_WATCH',
  AWS_CLOUD_WATCH_EVENTS = 'AWS_CLOUD_WATCH_EVENTS',
  AWS_CLOUD_WATCH_LOGS = 'AWS_CLOUD_WATCH_LOGS',
  AWS_CODE_BUILD = 'AWS_CODE_BUILD',
  AWS_CODE_COMMIT = 'AWS_CODE_COMMIT',
  AWS_CODE_DEPLOY = 'AWS_CODE_DEPLOY',
  AWS_CODE_PIPELINE = 'AWS_CODE_PIPELINE',
  AWS_CODE_STAR = 'AWS_CODE_STAR',
  AWS_COGNITO_IDENTITY = 'AWS_COGNITO_IDENTITY',
  AWS_COGNITO_SYNC = 'AWS_COGNITO_SYNC',
  AWS_COGNITO_USER_POOLS = 'AWS_COGNITO_USER_POOLS',
  AWS_COMPREHEND = 'AWS_COMPREHEND',
  AWS_COMPREHEND_MEDICAL = 'AWS_COMPREHEND_MEDICAL',
  AWS_CONFIG = 'AWS_CONFIG',
  AWS_CONNECT = 'AWS_CONNECT',
  AWS_COST_USAGE_REPORT = 'AWS_COST_USAGE_REPORT',
  AWS_COST_EXPLORER_SERVICE = 'AWS_COST_EXPLORER_SERVICE',
  AWS_DATA_LIFECYCLE_MANAGER = 'AWS_DATA_LIFECYCLE_MANAGER',
  AWS_DATA_PIPELINE = 'AWS_DATA_PIPELINE',
  AWS_DATA_SYNC = 'AWS_DATA_SYNC',
  AWS_DEEP_LENS = 'AWS_DEEP_LENS',
  AWS_DEVICE_FARM = 'AWS_DEVICE_FARM',
  AWS_DIRECT_CONNECT = 'AWS_DIRECT_CONNECT',
  AWS_DIRECTORY_SERVICE = 'AWS_DIRECTORY_SERVICE',
  AWS_DMS = 'AWS_DMS',
  AWS_DYNAMO_DB_ACCELERATOR = 'AWS_DYNAMO_DB_ACCELERATOR',
  AWS_EC2_AUTO_SCALING = 'AWS_EC2_AUTO_SCALING',
  AWS_EC2_MESSAGES = 'AWS_EC2_MESSAGES',
  AWS_EI = 'AWS_EI',
  AWS_EKS = 'AWS_EKS',
  AWS_ELASTIC_CONTAINER_REGISTRY = 'AWS_ELASTIC_CONTAINER_REGISTRY',
  AWS_ELASTIC_CONTAINER_SERVICE = 'AWS_ELASTIC_CONTAINER_SERVICE',
  AWS_ELASTIC_TRANSCODER = 'AWS_ELASTIC_TRANSCODER',
  AWS_ELASTIC_CACHE = 'AWS_ELASTIC_CACHE',
  AWS_ELASTIC_SEARCH_SERVICE = 'AWS_ELASTIC_SEARCH_SERVICE',
  AWS_EMR = 'AWS_EMR',
  AWS_EXECUTE_API = 'AWS_EXECUTE_API',
  AWS_FIREHOSE = 'AWS_FIREHOSE',
  AWS_FIREWALL_MANAGER = 'AWS_FIREWALL_MANAGER',
  AWS_FREE_RTOS = 'AWS_FREE_RTOS',
  AWS_FSX = 'AWS_FSX',
  AWS_GAME_LIFT = 'AWS_GAME_LIFT',
  AWS_GLACIER = 'AWS_GLACIER',
  AWS_GLOBAL_ACCELERATOR = 'AWS_GLOBAL_ACCELERATOR',
  AWS_GREENGRASS = 'AWS_GREENGRASS',
  AWS_GROUND_TRUTH_LABELING = 'AWS_GROUND_TRUTH_LABELING',
  AWS_GUARD_DUTY = 'AWS_GUARD_DUTY',
  AWS_IMPORT_EXPORT = 'AWS_IMPORT_EXPORT',
  AWS_INSPECTOR = 'AWS_INSPECTOR',
  AWS_IOT = 'AWS_IOT',
  AWS_IOT_1CLICK = 'AWS_IOT_1CLICK',
  AWS_IOT_ANALYTICS = 'AWS_IOT_ANALYTICS',
  AWS_IOT_EVENTS = 'AWS_IOT_EVENTS',
  AWS_IOT_SITE_WISE = 'AWS_IOT_SITE_WISE',
  AWS_KINESIS = 'AWS_KINESIS',
  AWS_KINESIS_ANALYTICS = 'AWS_KINESIS_ANALYTICS',
  AWS_KINESIS_VIDEO_STREAMS = 'AWS_KINESIS_VIDEO_STREAMS',
  AWS_LEX = 'AWS_LEX',
  AWS_LICENSE_MANAGER = 'AWS_LICENSE_MANAGER',
  AWS_LIGHTSAIL = 'AWS_LIGHTSAIL',
  AWS_MACHINE_LEARNING = 'AWS_MACHINE_LEARNING',
  AWS_MACIE = 'AWS_MACIE',
  AWS_MARKETPLACE = 'AWS_MARKETPLACE',
  AWS_MARKETPLACE_METERING = 'AWS_MARKETPLACE_METERING',
  AWS_MARKETPLACE_PORTAL = 'AWS_MARKETPLACE_PORTAL',
  AWS_MECHANICAL_TURK = 'AWS_MECHANICAL_TURK',
  AWS_MEDIA_CONNECT = 'AWS_MEDIA_CONNECT',
  AWS_MEDIA_CONVERT = 'AWS_MEDIA_CONVERT',
  AWS_MEDIA_LIVE = 'AWS_MEDIA_LIVE',
  AWS_MEDIA_PACKAGE = 'AWS_MEDIA_PACKAGE',
  AWS_MEDIA_STORE = 'AWS_MEDIA_STORE',
  AWS_MEDIA_TAILOR = 'AWS_MEDIA_TAILOR',
  AWS_MIGRATION_HUB = 'AWS_MIGRATION_HUB',
  AWS_MOBILE_ANALYTICS = 'AWS_MOBILE_ANALYTICS',
  AWS_MOBILE_HUB = 'AWS_MOBILE_HUB',
  AWS_MQ = 'AWS_MQ',
  AWS_MSK = 'AWS_MSK',
  AWS_NEPTUNE = 'AWS_NEPTUNE',
  AWS_OPS_WORKS = 'AWS_OPS_WORKS',
  AWS_OPS_WORKS_CM = 'AWS_OPS_WORKS_CM',
  AWS_ORGANIZATIONS = 'AWS_ORGANIZATIONS',
  AWS_PERFORMANCE_INSIGHTS = 'AWS_PERFORMANCE_INSIGHTS',
  AWS_PINPOINT = 'AWS_PINPOINT',
  AWS_PINPOINT_SMS_VOICE = 'AWS_PINPOINT_SMS_VOICE',
  AWS_POLLY = 'AWS_POLLY',
  AWS_PRICE_LIST = 'AWS_PRICE_LIST',
  AWS_PRIVATE_MARKETPLACE = 'AWS_PRIVATE_MARKETPLACE',
  AWS_QUICK_SIGHT = 'AWS_QUICK_SIGHT',
  AWS_REKOGNITION = 'AWS_REKOGNITION',
  AWS_RESOURCE_ACCESS_MANAGER = 'AWS_RESOURCE_ACCESS_MANAGER',
  AWS_RESOURCE_GROUP_TAGGING = 'AWS_RESOURCE_GROUP_TAGGING',
  AWS_RESOURCE_GROUPS = 'AWS_RESOURCE_GROUPS',
  AWS_ROBO_MAKER = 'AWS_ROBO_MAKER',
  AWS_ROUTE_53 = 'AWS_ROUTE_53',
  AWS_ROUTE_53_RESOLVER = 'AWS_ROUTE_53_RESOLVER',
  AWS_ROUTE_53_DOMAINS = 'AWS_ROUTE_53_DOMAINS',
  AWS_SAGE_MAKER = 'AWS_SAGE_MAKER',
  AWS_SECRETS_MANAGER = 'AWS_SECRETS_MANAGER',
  AWS_SECURITY_HUB = 'AWS_SECURITY_HUB',
  AWS_SERVERLESS_APPLICATION_REPOSITORY = 'AWS_SERVERLESS_APPLICATION_REPOSITORY',
  AWS_SERVER_MIGRATION_SERVICE = 'AWS_SERVER_MIGRATION_SERVICE',
  AWS_SERVICE_CATALOG = 'AWS_SERVICE_CATALOG',
  AWS_SES = 'AWS_SES',
  AWS_SHIELD = 'AWS_SHIELD',
  AWS_SIGNER = 'AWS_SIGNER',
  AWS_SNOWBALL = 'AWS_SNOWBALL',
  AWS_SNS = 'AWS_SNS',
  AWS_SSM_MESSAGES = 'AWS_SSM_MESSAGES',
  AWS_SSO = 'AWS_SSO',
  AWS_SSO_DIRECTORY = 'AWS_SSO_DIRECTORY',
  AWS_STEP_FUNCTIONS = 'AWS_STEP_FUNCTIONS',
  AWS_STORAGE_GATEWAY = 'AWS_STORAGE_GATEWAY',
  AWS_SUMERIAN = 'AWS_SUMERIAN',
  AWS_SUPPORT = 'AWS_SUPPORT',
  AWS_SWF = 'AWS_SWF',
  AWS_TEXTRACT = 'AWS_TEXTRACT',
  AWS_TRANSCRIBE = 'AWS_TRANSCRIBE',
  AWS_TRANSFER = 'AWS_TRANSFER',
  AWS_TRANSLATE = 'AWS_TRANSLATE',
  AWS_TRUSTED_ADVISOR = 'AWS_TRUSTED_ADVISOR',
  AWS_WAF = 'AWS_WAF',
  AWS_WAF_REGIONAL = 'AWS_WAF_REGIONAL',
  AWS_WAM = 'AWS_WAM',
  AWS_WELL_ARCHITECTED_TOOL = 'AWS_WELL_ARCHITECTED_TOOL',
  AWS_WORK_DOCS = 'AWS_WORK_DOCS',
  AWS_WORK_LINK = 'AWS_WORK_LINK',
  AWS_WORK_MAIL = 'AWS_WORK_MAIL',
  AWS_WORKSPACES = 'AWS_WORKSPACES',
  AWS_X_RAY = 'AWS_X_RAY',
  AWS_SIMPLE_DB = 'AWS_SIMPLE_DB',
  AWS_SYSTEMS_MANAGER = 'AWS_SYSTEMS_MANAGER',
  AWS_RTB = 'AWS_RTB',
  AWS_EIPALLOC = 'AWS_EIPALLOC',
  AWS_PCX = 'AWS_PCX',
  AWS_LAMBDA = 'AWS_LAMBDA',
  AZURE_STORAGE_ACCOUNT = 'AZURE_STORAGE_ACCOUNT',
  AZURE_STORAGE_CONTAINER = 'AZURE_STORAGE_CONTAINER',
  AZURE_KEY_VAULT = 'AZURE_KEY_VAULT',
  AZURE_REDIS_CACHE = 'AZURE_REDIS_CACHE',
  AZURE_SQL_DB = 'AZURE_SQL_DB',
  AZURE_VIRTUAL_NETWORK = 'AZURE_VIRTUAL_NETWORK',
  AZURE_NETWORK_SECURITY_GROUP = 'AZURE_NETWORK_SECURITY_GROUP',
  AZURE_SUBNET = 'AZURE_SUBNET',
  AZURE_RT = 'AZURE_RT',
  AZURE_SQL_SERVER = 'AZURE_SQL_SERVER',
  AZURE_KEYVAULT_KEY = 'AZURE_KEYVAULT_KEY',
  AZURE_KEYVAULT_SECRET = 'AZURE_KEYVAULT_SECRET',
  AZURE_DISK = 'AZURE_DISK',
  AZURE_COSMOS_DB = 'AZURE_COSMOS_DB',
  AZURE_LOAD_BALANCER = 'AZURE_LOAD_BALANCER',
  AZURE_FUNCTION_APP = 'AZURE_FUNCTION_APP',
  GCP_STORAGE_BUCKET = 'GCP_STORAGE_BUCKET',
  GCP_DISK = 'GCP_DISK',
  GCP_VPC = 'GCP_VPC',
  GCP_SUBNET = 'GCP_SUBNET',
  GCP_CLOUD_SQL_INSTANCE = 'GCP_CLOUD_SQL_INSTANCE',
  GCP_CLOUD_SQL_DB = 'GCP_CLOUD_SQL_DB',
  GCP_KMS_KEYRING = 'GCP_KMS_KEYRING',
  GCP_KMS_KEYRING_KEY = 'GCP_KMS_KEYRING_KEY',
  GCP_FIREWALL_RULES = 'GCP_FIREWALL_RULES',
  GCP_ROUTE = 'GCP_ROUTE',
  GCP_DATASTORE = 'GCP_DATASTORE',
  GCP_BIGTABLE_INSTANCE = 'GCP_BIGTABLE_INSTANCE',
  GCP_BIGTABLE_TABLE = 'GCP_BIGTABLE_TABLE',
  GCP_BIG_QUERY_DATASET = 'GCP_BIG_QUERY_DATASET',
  GCP_BIG_QUERY_TABLE = 'GCP_BIG_QUERY_TABLE',
  GCP_CLOUD_FUNCTION = 'GCP_CLOUD_FUNCTION',
  RESOURCE_END = 'RESOURCE_END',
  POLICY = 'POLICY',
  EXT_ACCOUNT = 'EXT_ACCOUNT',
  ACCOUNT_DATA = 'ACCOUNT_DATA',
  PRIV_ACTION = 'PRIV_ACTION',
  AZURE_ROLE_ASSIGNMENT = 'AZURE_ROLE_ASSIGNMENT',
  AZURE_SUBSCRIPTION_SETTINGS = 'AZURE_SUBSCRIPTION_SETTINGS',
  VERSION = 'VERSION',
  GCP_IAM_POLICY = 'GCP_IAM_POLICY',
  GCP_PROJECT = 'GCP_PROJECT',
  GCP_FOLDER = 'GCP_FOLDER',
  SERVICE = 'SERVICE',
  RESOURCE_TYPE_ALL = 'RESOURCE_TYPE_ALL'
}

export enum UserSource {
  SOURCE_UNKNOWN = 'SOURCE_UNKNOWN',
  COGNITO = 'COGNITO',
  IDN_IDP = 'IDN_IDP'
}

export enum ObjectChangeStatusEnum {
  OBJECT_STATUS_UNCHANGED = 'OBJECT_STATUS_UNCHANGED',
  OBJECT_STATUS_ADDED = 'OBJECT_STATUS_ADDED',
  OBJECT_STATUS_DELETED = 'OBJECT_STATUS_DELETED'
}

export enum ObjectSubordinationEnum {
  SUBORDINATION_NONE = 'SUBORDINATION_NONE',
  SUBORDINATION_IDENTITY = 'SUBORDINATION_IDENTITY',
  SUBORDINATION_OBJECT = 'SUBORDINATION_OBJECT',
  SUBORDINATION_POLICY = 'SUBORDINATION_POLICY'
}

export enum SuppressionTypeEnum {
  ALERT_SUPPRESSION_NONE = 'ALERT_SUPPRESSION_NONE',
  ALERT_SUPPRESSION_OBJECT = 'ALERT_SUPPRESSION_OBJECT',
  ALERT_SUPPRESSION_IDENTITY = 'ALERT_SUPPRESSION_IDENTITY',
  ALERT_SUPPRESSION_BOTH = 'ALERT_SUPPRESSION_BOTH'
}

export enum ETCDEventTypeEnum {
  ETCD_EVENT_TYPE_UNKNOWN = 'ETCD_EVENT_TYPE_UNKNOWN',
  ETCD_EVENT_TYPE_CREATED = 'ETCD_EVENT_TYPE_CREATED',
  ETCD_EVENT_TYPE_UPDATED = 'ETCD_EVENT_TYPE_UPDATED',
  ETCD_EVENT_TYPE_DELETED = 'ETCD_EVENT_TYPE_DELETED'
}
